import VueRouter from 'vue-router';
import Login from './Login';
import Home from './Home';
import AuditRoute from './entries/Audit/route';
import TicketRoute from './entries/Ticket/route';
import WalletRoute from './entries/Wallet/route';
import ReconciliationRoute from './entries/Reconciliation/route';
import UserRoute from './entries/User/route';
import SettingRoute from './entries/Setting/route';
import LogsRoute from './entries/Logs/route';
import MyTokenRoute from './entries/MyToken/route';
import AppRoute from './entries/App/route';
import TradeWhitelistRoute from './entries/TradeWhitelist/route';
import TransferApprovalWhitelist from './entries/TransferApprovalWhitelist/route';
import WithdrawApprovalWhitelist from './entries/WithdrawApprovalWhitelist/route';
import UserBillRoute from './entries/UserBill/route';
import TXRecordRoute from './entries/TXRecord/route';
import MessageRoute from './entries/Message/route';
import DashboardRoute from './entries/Dashboard/route';
import VoteRoute from './entries/Vote/route';
import FoundationRoute from './entries/Foundation/route';
import MerchantRoute from './entries/Merchant/route';
import PledgeRoute from './entries/Pledge/route';
import AirDropRoute from './entries/AirDrop/route';
import VotingStrategyRoute from './entries/VotingStrategy/route';
import MiningRoute from './entries/Mining/route';
import QuizRoute from './entries/Quiz/route';
import NoticeRoute from './entries/Notice/route';
import DoubleEleven from './entries/doubleEleven/route';
import MagicBox from './entries/MagicBox/route';
import NftMesg from './entries/Nft/route';
import EmailRoute from './entries/Email/route';
import TradeActivity from './entries/TradeStatistic/route';
import TradeException from './entries/TradeException/route';
import Machine from './entries/Machine/route';
import Transfer from './entries/Transfer/route';
import Agreement from './entries/Agreement/route';
import Coupon from './entries/coupon/route';
import Account from './entries/Account/route';
import ContractActivity from './entries/ContractActivity/route';
import ContractFeeRoute from './entries/ContractFee/route';
import FinanceManage from './entries/FinanceManage/route';
import DataCenter from './entries/DataCenter/route';
import PortalManage from './entries/portal/route';
import ProductManage from './entries/Product/route';
import RedPacket from './entries/RedPacket/route';
import RaiseFunds from './entries/raiseFunds/route';
import BatchEmail from './entries/batchEmail/route';
import Arena from './entries/Arena/route';
import Hashrate from './entries/hashrate/route';
import CoinRebase from './entries/CoinRebase/route';
import Sweep from './entries/Sweep/route';
import Refund from './entries/Refund/route';
import Mining2 from './entries/Mining2/route';
import Staking from './entries/Staking/route';
import Traders from './entries/Traders/route';
import CmsRoute from './entries/cms/route';
import SnapshotStatistic from './entries/SnapshotStatistic/route';
import BkkDestroy from './entries/BkkDestroy/route';
import MarketsSheet from './entries/HedgeCenter/MarketSheet/route';
import RobotMaintenance from './entries/HedgeCenter/RobotMaintenance/route';
import AccountReconciliation from './entries/HedgeCenter/AccountReconciliation/route';
import Focus from './entries/Focus/route';
import RiskController from './entries/RiskController/route';
import PartnerBalance from './entries/PartnerCenter/BalanceCollect/route';
import Strategy from './entries/Strategy/route';
import EtpManage from './entries/EtpManage/route';
import Cache from './entries/Cache/route';
import Agent from './entries/Agent/route';
import UserDistinguish from './entries/MarketCenter/userDistinguish/route';
import BalanceBook from './entries/HedgeCenter/BalanceBook/route';
import ContractBian from './entries/ContractBian/route';
import Purchase from './entries/Purchase/route';
import Incubator from './entries/Incubator/route';
import Snapshot from './entries/Snapshot/route';
import Statistics from './entries/statistics/route';
import Bonus from './entries/Bonus/route';
import Community from './entries/Community/route';
import BurnCoinBonus from './entries/BurnCoinBonus/route';
import Withdrawals from './entries/WithdrawalProcedures/route';
import UserTips from './entries/UserTips/route';
import fundDetails from "./entries/FundDetails/route";

const routes = [
    {path: '/', component: Login},
    {
        path: '/home',
        component: Home,
        children: [
            AuditRoute,
            TicketRoute,
            WalletRoute,
            ReconciliationRoute,
            UserRoute,
            SettingRoute,
            LogsRoute,
            MyTokenRoute,
            AppRoute,
            TradeWhitelistRoute,
            TransferApprovalWhitelist,
            WithdrawApprovalWhitelist,
            UserBillRoute,
            TXRecordRoute,
            MessageRoute,
            DashboardRoute,
            VoteRoute,
            FoundationRoute,
            MerchantRoute,
            PledgeRoute,
            AirDropRoute,
            VotingStrategyRoute,
            MiningRoute,
            QuizRoute,
            NoticeRoute,
            EmailRoute,
            TradeActivity,
            TradeException,
            Machine,
            Transfer,
            Agreement,
            DoubleEleven,
            Coupon,
            Account,
            ContractActivity,
            FinanceManage,
            DataCenter,
            ContractFeeRoute,
            PortalManage,
            ProductManage,
            RedPacket,
            RaiseFunds,
            BatchEmail,
            Arena,
            RedPacket,
            Traders,
            Hashrate,
            CoinRebase,
            Sweep,
            Refund,
            Mining2,
            CmsRoute,
            Staking,
            SnapshotStatistic,
            BkkDestroy,
            MarketsSheet,
            RobotMaintenance,
            AccountReconciliation,
            Focus,
            PartnerBalance,
            Strategy,
            EtpManage,
            Cache,
            RiskController,
            Agent,
            UserDistinguish,
            BalanceBook,
            ContractBian,
            Purchase,
            Snapshot,
            Statistics,
            Bonus,
            Community,
            BurnCoinBonus,
            Incubator,
            Withdrawals,
            UserTips,
            MagicBox,
            fundDetails,
            NftMesg,
            {
                path: '/home/withdrawNft',
                component: () => import('./entries/WithdrawNFT/index')
            }
        ]
    }
];

export default new VueRouter({
    routes
});
